import { MentionNodeAttrs } from "@components/NoteEditor/nodes";
import { openEntityInNewTab } from "@utils/navigation.util";

/** Opens the Meridian page for a note-editor mention. */
export const openNoteMentionInNewTab = (mention: MentionNodeAttrs) =>
  openEntityInNewTab({
    type: mention.type,
    id: mention.id,
    searchQuery: "title" in mention ? mention.title : undefined,
    meetingType: mention.type === "meeting" ? mention.__original_item.type : undefined,
  });
